import { Component, OnInit, Inject } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { UserUrl } from '../../../shared/urls/user.url';
import { BaseUrl } from '../../../shared/urls/base.url';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { UserModel } from '../../../models/user/user.model';

@Component({
  selector: 'assign-user-popup',
  templateUrl: './assign-user-popup.component.html'
})

export class AssignUserPopupComponent implements OnInit {
  public appMessages = AppMessages;
  public assignUserForm: FormGroup;
  public isAssignSuccess = false;
  public roleData = [];

  constructor(private formBuilder: FormBuilder,
    public utility: Utility,
    private baseService: BaseService,
    public dialogService: DialogService,
    public dialogRef: MdDialogRef<AssignUserPopupComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.createForm();
    this.getRoleDataInit();
  }

  public getRoleDataInit() {
    let url = UserUrl.GET_ROLES;
    this.roleData = [];
    this.baseService.getData(url).subscribe(
      (result) => {
        if (result) {
          this.roleData = result.json();          
        }
      }
    );
  }

  public createForm() {
    this.assignUserForm = this.formBuilder.group({
      RoleId: ['', [Validators.required]]
    });
  }


  public onSubmit() {
    if (this.assignUserForm.dirty && this.assignUserForm.valid) {
      let url = UserUrl.ASSIGN_CENTRE_USER.replace("{userId}", this.data.id).replace("{roleId}", this.assignUserForm.controls["RoleId"].value);
      this.baseService.postData(url, null).subscribe(
        (result) => {
          if (result) {
            // update success value to reload the list
            this.isAssignSuccess = true;
            // success then close dialog and open success confirm dialog
            this.onCloseDialog();
            this.dialogService.openSuccessDialog({ message: result.json().message });
          }
        },
        error => {

        }
      );
    }
  }

  public onCloseDialog() {
    this.dialogRef.close(this.isAssignSuccess);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/assign-user/assign-user-popup.component.ts